<app-ion-common-header
  [id]="headerId"
  (backHeader)="backPage()"
  (focusHeader)="shownContent()"
  [title]="titlePage"
  start="{{startStage}}"
  end="{{endStage}}"
></app-ion-common-header>

<ion-content
  *ngIf="!showRetry && !loading"
  [attr.aria-hidden]="ariaHidden"
  [style.visibility]="ariaHidden ? 'hidden' : 'visible'"
>
  <div
    class="content-list content-scroll"
    [ngClass]="{'content-list--with-button' : selectedItem}"
  >
    <app-ion-common-label
      [id]="idLabelMaritalStatus"
      class="document-type-label1"
      labelStyle="display-rg"
      labelDescription="Qual seu estado civil?"
    >
    </app-ion-common-label>

    <div class="conent-center">
      <app-ion-common-radio
        [id]="idRadioMaritalStatus"
        class="document-type-options"
        [itens]="maritalStatus"
        [selectedValue]="selectedItem"
        (changeRadio)="selectedItem = $event"
        (valueNameRadio)="selectedName=$event"
        [disabled]="!this.edit"
      ></app-ion-common-radio>
    </div>
  </div>

  <app-ion-common-button
    [id]="idButtonMaritalStatus"
    class="hidden"
    [ngClass]="{'hidden': selectedItem?.length === 0}"
    [attr.aria-hidden]="selectedItem?.length === 0"
    (clickButton)="clickNext();"
    label="Continuar"
  ></app-ion-common-button>
</ion-content>

<ion-content *ngIf="showRetry">
  <app-ion-common-retry
    [headerId]="headerId"
    (sendEventRetry)="getMaritalStatus()"
  >
  </app-ion-common-retry>
</ion-content>
